import React,{ useState,useEffect, useTransition } from "react";

interface TestComponentProps {
    testName: string,
    age: number
}

export function TestComponent(props:TestComponentProps) {

    const [clickNum,setClickNum] = useState<number>(0);
    const [searchQuery,setSearchQuery] = useState<any[]>([]);
    const [loading,startTransition] = useTransition();

    useEffect(()=>{
        //setClickNum(clickNum + 100);
        console.log('TestComponent useEffect run...');
        return () => {
            console.log(`TestComponent useEffect return${clickNum}`);
        };
    },[clickNum]
    );
    const handleClick = () => {
        setClickNum(clickNum + 1);
    }

    const handleChange = (e:any) => {
        startTransition(()=>{
            setSearchQuery(Array(2000).fill(e.target.value));
        })
    }

    return (
    <div>
       My name is {props.testName},and my age is {props.age}
       <p>clickNum:{clickNum}</p>
       <button onClick={handleClick}>点击计数</button>
       <br/>
       <input aria-label="请输入值" onChange={handleChange}/>
       { loading ? (<p>loading</p>) :
        ((searchQuery.map((item,index) => <p key={index}>{item}</p>)))}
    </div>
    );
}